import type { IconSvgObject } from './types';

const ZoomOutAreaIcon: IconSvgObject = [
  ["path", { d: "M18.5016 18.5L21 21M20 14.5C20 11.4624 17.5376 9 14.5 9C11.4624 9 9 11.4624 9 14.5C9 17.5376 11.4624 20 14.5 20C17.5376 20 20 17.5376 20 14.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.5 14.5H12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17.5 3H19C20.1046 3 21 3.89543 21 5V6.5M3 6.5V5C3 3.89543 3.89543 3 5 3H6.5M6.5 21H5C3.89543 21 3 20.1046 3 19V17.5M10 3H14M3 10V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ZoomOutAreaIcon;
